export default "__VITE_ASSET__CBp7JZUx__"